import { logger } from '@/modules/common/logging/logger';
import { LayerNames, LayerVisibilityMode, StoredLayers } from '@/modules/common/types/layers';

import { ILayerService } from './ILayerService';

export class LayerServiceLogDecorator implements ILayerService {
  private decoree: ILayerService;

  constructor(decoree: ILayerService) {
    this.decoree = decoree;
  }

  setLayerVisibilityMode(layerName: LayerNames, mode: LayerVisibilityMode): void {
    const start = this.logStart(`setLayerVisibilityMode -> ${layerName} -> ${mode}`);
    this.decoree.setLayerVisibilityMode(layerName, mode);
    this.logEnd(`setLayerVisibilityMode -> ${layerName} -> ${mode}`, start);
  }

  loadLayerVisibilityModes(visibilityModes: Partial<Record<LayerNames, LayerVisibilityMode>>): void {
    const start = this.logStart('loadLayerVisibilityModes');
    this.decoree.loadLayerVisibilityModes(visibilityModes);
    this.logEnd('loadLayerVisibilityModes', start);
  }

  showAllElements(): void {
    const start = this.logStart('showAllElements');
    this.decoree.showAllElements();
    this.logEnd('showAllElements', start);
  }

  hideElements(idsToHide: string[]): void {
    const start = this.logStart('hideElements');
    this.decoree.hideElements(idsToHide);
    this.logEnd('hideElements', start);
  }

  showElements(idsToShow: string[]): void {
    const start = this.logStart('showElements');
    this.decoree.showElements(idsToShow);
    this.logEnd('showElements', start);
  }

  setLayerLock(layerName: LayerNames, lock: boolean): void {
    const start = this.logStart(`setLayerLock -> ${layerName} -> ${lock}`);
    this.decoree.setLayerLock(layerName, lock);
    this.logEnd(`setLayerLock -> ${layerName} -> ${lock}`, start);
  }

  lockElements(idsToLock: string[]): void {
    const start = this.logStart('lockElements');
    this.decoree.lockElements(idsToLock);
    this.logEnd('lockElements', start);
  }

  unlockElements(idsToUnlock: string[]): void {
    const start = this.logStart('unlockElements');
    this.decoree.unlockElements(idsToUnlock);
    this.logEnd('unlockElements', start);
  }

  loadLayersState(layers: StoredLayers): void {
    const start = this.logStart('loadLayersState');
    this.decoree.loadLayersState(layers);
    this.logEnd('loadLayersState', start);
  }

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    const duration = performance.now() - start;
    logger.info(`End -> ${methodName} (${duration.toFixed(2)}ms)`);
  }
}
